// extracted by mini-css-extract-plugin
module.exports = {"vimeoPlayerContainer":"VimeoPlayer_vimeoPlayerContainer__7T1LH","grid":"VimeoPlayer_grid__2rSe0","enableControls":"VimeoPlayer_enableControls__vwYqK"};